export default function PrivacyPolicy() {
  return (
    <main className="min-h-screen bg-gray-50 w-full py-6 sm:py-10 px-3 sm:px-4">
      <div className="mx-auto w-full max-w-4xl">
        {/* Header */}
        <header className="mb-6 sm:mb-8">
          <h1 className="text-xl sm:text-3xl text-center font-bold tracking-tight text-gray-900">
            개인정보 수집 및 이용 동의서
          </h1>
        </header>

        {/* Card */}
        <section className="rounded-2xl bg-white p-4 sm:p-8 shadow-sm ring-1 ring-gray-200">
          {/* Intro */}
          <div className="space-y-3 text-[13px] sm:text-sm leading-6 sm:leading-7 text-gray-700">
            <p className="font-semibold">개인정보 수집 및 이용안내</p>
            <p>
              주식회사 위지온(이하 “회사”)는 이용자의 개인정보를 중요시하며 정보통신망 이용촉진 및
              정보보호 등에 관한 법률” 등 관련법령을 준수하고 있습니다. 회사는 개인정보취급방침을
              통하여 정보주체 개인정보가 어떠한 용도와 방식으로 이용되고 있으며 개인정보를 위해
              어떠한 조치가 취해지고 있는지 알려드립니다.
            </p>
            <p>
              이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과 같이 개인정보
              처리방침을 수립·공개합니다. 회사는 개인정보처리방침을 개정하는 경우 회사의 홈페이지 내
              공지사항(또는 개별공지)을 통하여 공지할 것입니다.
            </p>
          </div>

          {/* TOC */}
          <div className="mt-6 sm:mt-8 rounded-xl bg-gray-50 p-4 ring-1 ring-gray-200">
            <ol className="list-decimal space-y-1 pl-5 text-[13px] sm:text-sm text-gray-700">
              <li>개인정보의 수집 및 이용목적</li>
              <li>개인정보의 수집항목 및 수집방법</li>
              <li>개인정보의 보유 및 이용기간</li>
              <li>개인정보의 제3자 제공</li>
              <li>개인정보 처리 위탁을 하는 업무의 내용 및 수탁자</li>
              <li>개인정보의 파기절차 및 방법</li>
              <li>개인정보의 안전성 확보조치</li>
              <li>이용자와 법정대리인의 권리와 의무 및 행사방법</li>
              <li>개인정보 보호책임자 및 이용자 고충처리</li>
              <li>이용자의 권익침해 구제방법</li>
              <li>개인정보처리방침의 변경 및 고지의무</li>
            </ol>
          </div>

          {/* Section 1 */}
          <div className="mt-8 sm:mt-10">
            <h2 className="text-base sm:text-lg font-semibold text-gray-900">
              1. 개인정보의 수집 및 이용목적
            </h2>

            <div className="mt-4 space-y-3 text-[13px] sm:text-sm leading-6 sm:leading-7 text-gray-700">
              <p>회사는 수집한 개인정보를 다음의 목적을 위해 활용합니다.</p>
              <p>
                개인정보는 다음 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는
                [개인정보 보호법] 제 18조 에 따라 별도의 동의를 받는 등 필요한 조치를 이행할
                예정입니다.
              </p>

              <ul className="list-disc space-y-2 pl-5">
                <li>서비스 제공의 성립, 유지, 업무처리, 종료를 위한 업무일체</li>
                <li>서비스 제공 과정 중 본인 식별, 인증, 실명확인 및 각종 안내/고지</li>
                <li>부정 이용방지 및 비인가 사용방지</li>
                <li>서비스 제공 및 관련 업무처리에 필요한 동의 또는 철회 등 의사확인</li>
                <li>이용 빈도 파악 및 인구통계학적 특성에 따른 서비스 제공 및 CRM</li>
                <li>서비스 제공을 위한 각 결제수단별 상점 사업자 정보 등록</li>
                <li>
                  서비스 제공(거래승인 등) 및 관련 업무처리(민원, 개인정보 관리상태 점검 등)를 위해
                  이용자와 해당 결제수단에 관한 계약을 체결한 이용자의 해당 결제수단 발행자 (ex.
                  신용카드의 경우 해당 신용카드사)에게 이용자의 결제정보, 개인정보 보관내역 등 전송
                </li>
                <li>
                  기타 회사가 제공하는 이벤트 등 광고성 정보 전달, 통계학적 특성에 따른 서비스 제공
                  및 광고 게재, 실제 마케팅 활동
                </li>
                <li>
                  특정 금융거래정보의 보고 및 이용 등에 관한 법률에 따른 고객확인 서비스
                  제공과정에서 아래와 같은 정보들이 자동으로 생성되어 수집될 수 있습니다.
                </li>
                <li>
                  PC웹, 모바일 웹 이용 과정에서 단말기정보(OS, 화면사이즈, 디바이스 아이디, 휴대전화
                  기종, 단말기 모델명), IP주소, 쿠키, 방문일시, 부정이용기록, 서비스 이용기록 등의
                  정보
                </li>
                <li>
                  고객 문의 및 상담 처리: 이용자 식별, 문의 사항 확인 및 원활한 상담 서비스 제공.
                </li>
                <li>
                  맞춤형 서비스 제안: 설문 응답 내용(사업 영역, 취급 상품, 정산 규모, 시급한 필요
                  기능 등) 분석을 통한 최적의 솔루션 안내 및 담당자 배정.
                </li>
                <li>
                  서비스 이용 기록 분석: 인구통계학적 특성에 따른 서비스 제공 및 서비스 개선을 위한
                  통계적 활용.
                </li>
              </ul>
            </div>
          </div>

          {/* Section 2 */}
          <div className="mt-8 sm:mt-10">
            <h2 className="text-base sm:text-lg font-semibold text-gray-900">
              2. 개인정보의 수집항목 및 수집방법
            </h2>

            <div className="mt-4 space-y-6 text-[13px] sm:text-sm leading-6 sm:leading-7 text-gray-700">
              <div className="space-y-3">
                <p className="font-semibold">수집항목</p>

                <div className="space-y-3">
                  <p>1) 전자금융거래서비스 이행(거래이용)과 관련된 수집 정보 </p>
                  <ul className="list-disc space-y-2 pl-5">
                    <li>이용자의 상품 또는 용역 거래정보</li>
                    <li>이용자의 이메일, 접속IP</li>
                    <li>
                      이용자의 거래정보 : 서비스를 구매하기 위해 제공하는 각 결제수단별 제반 정보로
                      카드사명, 카드번호(일부), 고객명, 생년월일, 성별, 가상계좌번호, 결제자 ID,
                      은행명, 예금주명, 통신사명, 휴대폰번호
                    </li>
                    <li>생년월일, 유선전화번호, 비밀번호 앞2자리</li>
                  </ul>
                </div>

                <div className="space-y-3">
                  <p>2) 서비스 이용신청(회원가입) 및 계약과 관련된 수집 정보</p>
                  <ul className="list-disc space-y-2 pl-5">
                    <li>
                      성명, 휴대폰번호, 이메일, 로그인ID, 비밀번호, 생년월일, 은행명, 계좌번호,
                      예금주명
                    </li>
                    <li>
                      통신사, 내/외국인 정보, CI(암호화된 동일인 식별정보), DI(중복가입 확인정보)
                    </li>
                  </ul>
                </div>

                <div className="space-y-3">
                  <p>3) 법인회원 관련 추가 수집 정보</p>
                  <ul className="list-disc space-y-2 pl-5">
                    <li>
                      사업자등록증 소정의 정보(법인명, 대표자명, 사업자등록번호, 대표전화번호,
                      업종/업태 등)
                    </li>
                    <li>
                      결제 및 환불 결제수단 정보(예금주명, 은행명, 계좌번호, 카드번호, 카드명칭 등)
                    </li>
                    <li>담당자 성명, 휴대폰번호, 이메일주소</li>
                    <li>아이디, 비밀번호, 서비스 가입ㆍ해지 및 이용기록</li>
                  </ul>
                </div>

                <div className="space-y-3">
                  <p>
                    4) "서비스” 이용 또는 처리 과정에서 자동 혹은 수동으로 생성되어 수집되는 정보
                  </p>
                  <ul className="list-disc space-y-2 pl-5">
                    <li>
                      IP주소, MAC주소, 쿠키, 서비스 이용기록, 방문기록, 불량 및 비정상 이용기록, OS
                      버전, 웹브라우저버전, 휴대기기정보, 주문정보(이용상점 정보, 상품명, 주문금액,
                      주문 및 승인시간정보)
                    </li>
                  </ul>
                </div>

                <div className="space-y-3">
                  <p>5) 품 서비스 신청 및 상담 신청 과정에서 수집되는 정보</p>
                  <ul className="list-disc space-y-2 pl-5">
                    <li>회원 및 문의 정보: 성명, 휴대폰번호, 이메일 주소, 회사명, 부서명</li>
                    <li>
                      설문 및 상담 정보: 주된 사업 영역, 취급 상품군, 필요 기능/서비스, 도입 시급성
                      및 목적, 예상 정산 규모, 서비스 인지 경로 등 설문지에 기재된 응답 내용 일체
                    </li>
                  </ul>
                </div>
              </div>

              <div className="space-y-3">
                <p className="font-semibold">수집방법</p>
                <ul className="list-disc space-y-2 pl-5">
                  <li>
                    회사가 운영하는 웹사이트 및 모바일앱 또는 회사가 제공하는 결제창에 이용자가 입력
                  </li>
                  <li>로그분석 프로그램을 통한 자동 수집</li>
                  <li>
                    서면양식(신규계약서 등), 팩스, 이메일 및 업무제휴 계약을 체결한 제휴사로부터
                    고객이 제시하는 개인정보
                  </li>
                  <li>
                    회사가 제공하는 정보통신서비스의 이용 혹은 처리 과정에서 쿠키, 서비스 접속로그
                    등이 자동으로 생성 및 수집되는 경우
                  </li>
                  <li>홈페이지에서 품 소개서 신청 및 품 도입문의 신청하는 경우 </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Section 3 */}
          <div className="space-y-4 text-[13px] sm:text-sm leading-6 sm:leading-7 text-gray-700 mt-8 sm:mt-10">
            <h2 className="text-base sm:text-lg font-semibold text-gray-900">
              3. 개인정보의 보유 및 이용기간
            </h2>

            <p>
              회사는 원칙적으로 개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를 지체없이
              파기합니다.
            </p>

            <p>
              단, 전자상거래 등에서의 소비자보호에 관한 법률, 전자금융거래법, 통신비밀보호법 등
              법령에서 일정기간 정보보관 의무를 부과하는 경우에는 해당 기간 동안 개인정보를 안전하게
              보관합니다. 다음의 정보에 대해서는 법률 규정에 따라 개인정보를 보관하며, 본 정보를
              다른 목적으로 이용하지 않습니다.
            </p>
          </div>

          {/* Table 3 */}
          <div className="mt-4 sm:mt-6 overflow-x-auto">
            <table className="min-w-[760px] w-full border border-gray-300 text-[13px] sm:text-sm text-gray-700">
              <thead className="bg-gray-100">
                <tr>
                  <th className="border border-gray-300 px-3 py-2 text-left">보존정보</th>
                  <th className="border border-gray-300 px-3 py-2 text-left">보존근거(법률)</th>
                  <th className="border border-gray-300 px-3 py-2 text-left">보존기간</th>
                </tr>
              </thead>
              <tbody>
                {/* (문구 동일, 행 동일) */}
                <tr>
                  <td className="border border-gray-300 px-3 py-2">
                    계약 또는 청약 철회 등에 관한 기록
                  </td>
                  <td className="border border-gray-300 px-3 py-2">
                    전자상거래 등에서의 소비자보호에 관한 법률
                  </td>
                  <td className="border border-gray-300 px-3 py-2">5년</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 px-3 py-2">
                    대금결제 및 재화 등의 공급에 관한 기록
                  </td>
                  <td className="border border-gray-300 px-3 py-2">
                    전자상거래 등에서의 소비자보호에 관한 법률
                  </td>
                  <td className="border border-gray-300 px-3 py-2">5년</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 px-3 py-2">
                    소비자 불만 또는 분쟁처리에 관한 기록
                  </td>
                  <td className="border border-gray-300 px-3 py-2">
                    전자상거래 등에서의 소비자보호에 관한 법률
                  </td>
                  <td className="border border-gray-300 px-3 py-2">3년</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 px-3 py-2">
                    건당1만원 초과 전자금융거래에 관한 기록
                  </td>
                  <td className="border border-gray-300 px-3 py-2">전자금융거래법</td>
                  <td className="border border-gray-300 px-3 py-2">5년</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 px-3 py-2">
                    건당1만원 이하 전자금융거래에 관한 기록
                  </td>
                  <td className="border border-gray-300 px-3 py-2">전자금융거래법</td>
                  <td className="border border-gray-300 px-3 py-2">1년</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 px-3 py-2">
                    신용정보의 수집·처리 및 이용등에 관한 기록
                  </td>
                  <td className="border border-gray-300 px-3 py-2">
                    신용정보의 이용 및 보호에 관한 법률
                  </td>
                  <td className="border border-gray-300 px-3 py-2">3년</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 px-3 py-2">
                    서비스 이용기록, 접속로그, 접속 IP정보
                  </td>
                  <td className="border border-gray-300 px-3 py-2">개인정보보호법</td>
                  <td className="border border-gray-300 px-3 py-2">1년</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 px-3 py-2">본인확인에 대한 기록</td>
                  <td className="border border-gray-300 px-3 py-2">
                    정보통신 이용촉진 및 정보보호에 관한 법률
                  </td>
                  <td className="border border-gray-300 px-3 py-2">6개월</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 px-3 py-2">웹사이트 방문에 대한 기록</td>
                  <td className="border border-gray-300 px-3 py-2">통신비밀보호법</td>
                  <td className="border border-gray-300 px-3 py-2">3개월</td>
                </tr>
                <tr>
                  <td className="border border-gray-300 px-3 py-2">서비스 상담으로 수집된 기록</td>
                  <td className="border border-gray-300 px-3 py-2">
                    회사내부 방침(※분쟁발생시 소명용으로 보관)
                  </td>
                  <td className="border border-gray-300 px-3 py-2">상담후 6개월</td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Section 4 */}
          <div className="space-y-4 text-[13px] sm:text-sm leading-6 sm:leading-7 text-gray-700 mt-8 sm:mt-10">
            <h2 className="text-base sm:text-lg font-semibold text-gray-900">
              4. 개인정보의 제3자 제공
            </h2>

            <p>
              1) 회사는 이용자의 개인정보를 개인정보의 처리목적에서 명시한 범위 내에서만 처리하며,
              정보주체의 동의, 법률의 특별한 규정 등 「개인정보 보호법」 제 17조 및 제18조에
              해당하는 경우에만 개인정보를 제3자에게 제공하고 그 이외에는 개인정보를 제3자에게
              제공하지 않습니다.
            </p>

            <p>
              2) 회사는 원활한 서비스 제공을 위해 다음의 경우 개인정보 보호법 제17조 제1항 제1호에
              따라 정보주체의 동의를 얻어 필요 최소한의 범위로만 제공합니다. 다만, 다음의 경우는
              예외로 합니다.
            </p>

            <ul className="list-disc space-y-2 pl-5">
              <li>이용자가 개인정보 제공에 직접 동의를 한 경우</li>
              <li>법률에 특별한 규정이 있거나 법령상 의무 준수를 위하여 불가피한 경우</li>
              <li>공공기관이 법령 등에서 정하는 소관 업무의 수행을 위하여 불가피한 경우</li>
              <li>
                이용자와 체결한 계약을 이행하거나 계약을 체결하는 과정에서 이용자의 요청에 따른
                조치를 이행하기 위하여 필요한 경우
              </li>
              <li>
                명백히 정보주체 또는 제3자의 급박한 생명, 신체, 재산의 이익을 위하여 필요하다고
                인정된 경우
              </li>
              <li>
                개인정보처리자의 정당한 이익을 달성하기 위하여 필요한 경우로서 명백하게 이용자의
                권리보다 우선하는 경우, 이 경우 개인정보처리자의 정당한 이익과 상당한 관련이 있고
                합리적인 범위를 초과하지 아니하는 경우에 한한다.
              </li>
              <li>공중위생 등 공공의 안전과 안녕을 위하여 긴급히 필요한 경우</li>
            </ul>
          </div>

          {/* Table 4 */}
          <div className="mt-4 md:mt-6 overflow-x-auto h-full overflow-y-auto">
            <table className="min-w-[980px] w-full border border-gray-300 text-[13px] sm:text-sm text-gray-700">
              <thead className="bg-gray-100">
                <tr>
                  <th className="border border-gray-300 px-3 py-2 text-left">제공목적</th>
                  <th className="border border-gray-300 px-3 py-2 text-left">제공받는 자</th>
                  <th className="border border-gray-300 px-3 py-2 text-left">제공정보</th>
                  <th className="border border-gray-300 px-3 py-2 text-left">보유 및 이용기간</th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td className="border border-gray-300 px-3 py-2">신용카드 결제 승인</td>
                  <td className="border border-gray-300 px-3 py-2">
                    갤럭시아머니트리㈜, ㈜헥토파이낸셜, ㈜나이스페이먼츠, ㈜다날, 한국정보통신㈜,
                    (주)섹타나인, NHN KCP, 웰컴페이먼츠(주), KIS정보통신(주), (주)스마트로,
                    (주)제이티넷, (주)코밴
                  </td>
                  <td className="border border-gray-300 px-3 py-2">
                    서비스 거래정보(이용상점정보, 상품명, 카드사명, 은행명, 카드번호(3rd-마스킹),
                    카드사정보, 거래금액, 결제정보와 연동된 간편결제 KEY), USER ID, 생년월일, 성명
                    등
                  </td>
                  <td className="border border-gray-300 px-3 py-2 align-middle" rowSpan={3}>
                    서비스 해지일 또는 이용계약 종료일
                  </td>
                </tr>

                <tr>
                  <td className="border border-gray-300 px-3 py-2">송금서비스 서비스 제공</td>
                  <td className="border border-gray-300 px-3 py-2">
                    더즌, ㈜나이스페이먼츠, 갤럭시아머니트리㈜
                  </td>
                  <td className="border border-gray-300 px-3 py-2">
                    송금이체 대상자 계좌정보(은행, 계좌번호, 예금주명, 이체금액 등)
                  </td>
                </tr>

                <tr>
                  <td className="border border-gray-300 px-3 py-2">현금영수증</td>
                  <td className="border border-gray-300 px-3 py-2">국세청 / ㈜케이에스넷</td>
                  <td className="border border-gray-300 px-3 py-2">
                    발행정보 (전화번호, 발행금액)
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Section 5 */}
          <div className="space-y-4 text-[13px] sm:text-sm leading-6 sm:leading-7 text-gray-700 mt-8 sm:mt-10">
            <h2 className="text-base sm:text-lg font-semibold text-gray-900">
              5. 개인정보 처리업무의 위탁
            </h2>

            <p>
              회사는 원활한 업무처리를 위하여 다음과 같이 개인정보 처리업무를 위탁하고 있으며, 관련
              법령에 따라 위탁계약 시 개인정보가 안전하게 관리될 수 있도록 필요한 사항을 규정하고
              있습니다.
            </p>
          </div>

          {/* Table 5 */}
          <div className="mt-4 sm:mt-6 overflow-x-auto">
            <table className="min-w-[760px] w-full border border-gray-300 text-[13px] sm:text-sm text-gray-700">
              <thead className="bg-gray-100">
                <tr>
                  <th className="border border-gray-300 px-3 py-2 text-left">위탁 업무</th>
                  <th className="border border-gray-300 px-3 py-2 text-left">위탁받는 자</th>
                  <th className="border border-gray-300 px-3 py-2 text-left">제공정보</th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td className="border border-gray-300 px-3 py-2">가상계좌 결제 수행</td>
                  <td className="border border-gray-300 px-3 py-2">가상계좌 사업자(제휴사)</td>
                  <td className="border border-gray-300 px-3 py-2">은행명, 이용자명</td>
                </tr>

                <tr>
                  <td className="border border-gray-300 px-3 py-2">
                    알림톡 발송(결제결과, 인증안내)
                  </td>
                  <td className="border border-gray-300 px-3 py-2">인포뱅크(재위탁:㈜카카오)</td>
                  <td className="border border-gray-300 px-3 py-2">
                    이용자명,휴대전화번호,결제금액
                  </td>
                </tr>

                <tr>
                  <td className="border border-gray-300 px-3 py-2">
                    SMS 발송(결제안내, 결제결과, 인증안내)
                  </td>
                  <td className="border border-gray-300 px-3 py-2">인포뱅크</td>
                  <td className="border border-gray-300 px-3 py-2">
                    이용자명,휴대전화번호,결제금액
                  </td>
                </tr>

                <tr>
                  <td className="border border-gray-300 px-3 py-2">본인인증</td>
                  <td className="border border-gray-300 px-3 py-2">한국모바일인증㈜</td>
                  <td className="border border-gray-300 px-3 py-2">
                    이용자명, 통신사, 휴대전화번호, 생년월일(+성별, 내/외국인)
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Section 6 */}
          <div className="space-y-4 text-[13px] sm:text-sm leading-6 sm:leading-7 text-gray-700 mt-8 sm:mt-10">
            <h2 className="text-base sm:text-lg font-semibold text-gray-900">
              6. 개인정보의 파기절차 및 방법
            </h2>

            <p>
              회사는 원칙적으로 개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를 지체없이
              파기합니다.
            </p>

            <p>
              1) 이용자로부터 동의받은 개인정보 보유기간이 경과하거나 처리목적이 달성되었음에도
              불구하고 다른 법령에 따라 개인정보를 계속 보존하여야 하는 경우에는, 해당 개인정보를
              별도의 데이터베이스로 옮기거나 보관장소를 달리하여 보존합니다.
            </p>
            <p>2) 개인정보 파기의 절차 및 방법</p>

            <div className="space-y-4">
              <p className="pl-5">① 파기절차</p>

              <ul className="list-disc space-y-2 pl-[60px]">
                <li>
                  회사는 파기 사유가 발생한 개인정보를 선정하고, 회사의 개인정보 보호책임자의 승인을
                  받아 개인정보를 파기합니다.
                </li>
              </ul>

              <p className="pl-5">② 파기방법</p>
              <ul className="list-disc space-y-2 pl-[60px]">
                <li>
                  회사는 전자적 파일 형태로 기록/저장된 개인정보는 기록을 재생할 수 없도록 파기하며,
                  종이문서에 기록/저장된 개인정보는 분쇄기로 분쇄하거나 소각하여 파기합니다.
                </li>
              </ul>
            </div>
          </div>

          {/* Section 7 */}
          <div className="space-y-4 text-[13px] sm:text-sm leading-6 sm:leading-7 text-gray-700 mt-8 sm:mt-10">
            <h2 className="text-base sm:text-lg font-semibold text-gray-900">
              7. 개인정보의 안전성 확보조치
            </h2>

            <p>회사는 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고 있습니다.</p>

            <div className="space-y-6">
              <div className="space-y-2">
                <p>1) 관리적 조치</p>
                <ul className="list-disc space-y-2 pl-5">
                  <li>개인정보 내부관리계획 수립·시행 및 전담조직 운영</li>
                  <li>개인정보취급자의 지정 최소화 및 정기적 직원교육</li>
                  <li>정기적 법적 준거성 검토</li>
                </ul>
              </div>

              <div className="space-y-2">
                <p>2) 기술적 조치</p>
                <ul className="list-disc space-y-2 pl-5">
                  <li>개인정보의 암호화</li>
                  <li>개인정보처리시스템 등의 접근권한 제한 및 접근통제</li>
                  <li>접속기록의 보관 및 위조·변조 방지 조치</li>
                  <li>보안프로그램 설치 및 갱신</li>
                  <li>침입탐지를 통한 보안관제 및 물리적 망분리</li>
                </ul>
              </div>

              <div className="space-y-2">
                <p>3) 물리적 조치</p>
                <ul className="list-disc space-y-2 pl-5">
                  <li>개인정보가 저장 및 보관된 장소의 시건, 출입통제 절차의 수립 및 운영</li>
                  <li>
                    천재지변 및 긴급재해 발생시 개인정보처리시스템 백업 및 복구를 위한 재해복구센터
                    구축 및 운영
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* Section 8 */}
          <div className="space-y-4 text-[13px] sm:text-sm leading-6 sm:leading-7 text-gray-700 mt-8 sm:mt-10">
            <h2 className="text-base sm:text-lg font-semibold text-gray-900">
              8. 이용자와 법정대리인의 권리와 의무 및 행사방법
            </h2>

            <p className="">
              1) 이용자는 회사에 대해 언제든지 개인정보 열람·정정·삭제·처리정지 요구 등의 권리를
              행사할 수 있습니다.
            </p>

            <p className="pl-5">
              ※ 만14세 미만 아동에 관한 개인정보의 열람 등 요구는 법정대리인이 직접 해야 하며,
              만14세 이상의 미성년자인 정보주체는 정보주체의 개인정보에 관하여 미성년자 본인이
              권리를 행사하거나 법정대리인을 통하여 권리를 행사할 수도 있습니다.
            </p>

            <p>
              2) 권리 행사는 회사에 대해 「개인정보 보호법」 시행령 제41조 제1항에 따라 서면,
              전자우편, 팩스 등을 통하여 할 수 있으며, 회사는 이에 대해 즉각 조치하겠습니다.
            </p>
            <p>
              3) 권리행사는 이용자의 법정대리인이나 위임을 받은 자 등 대리인을 통하여 할 수도
              있습니다. 이 경우 “개인정보 처리방법에 관한 고시(제2023-12호)”별지 제11호 서식에 따른
              위임장을 제출해야 합니다.
            </p>
            <p>
              4) 개인정보 열람 및 처리정지 요구는 「개인정보 보호법」 제35조 제4항 및 제37조 제2항에
              의하여 정보주체의 권리가 제한될 수 있습니다.
            </p>
            <p>
              5) 개인정보의 정정 및 삭제요구는 다른 법령에서 그 개인정보가 수집 대상으로 명시되어
              있는 경우에는 그 삭제를 요구할 수 없습니다.
            </p>
            <p>
              6) 회사는 이용자 권리에 따른 열람의 요구, 정정·삭제의 요구, 처리정지의 요구 시 열람 등
              요구를 한 자가 본인이거나 정당한 대리인인지를 확인하여야 합니다.
            </p>
          </div>

          {/* Section 9 */}
          <div className="space-y-4 text-[13px] sm:text-sm leading-6 sm:leading-7 text-gray-700 mt-8 sm:mt-10">
            <h2 className="text-base sm:text-lg font-semibold text-gray-900">
              9. 개인정보 보호책임자 및 이용자 고충처리
            </h2>

            <p>
              1) 회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고 서비스 이용 중 발생하는
              개인정보 관련 민원, 불만처리 및 피해구제를 위해 개인정보 보호책임자 및 전담부서를
              운영하고 있습니다.
            </p>
            <p>
              2) 이용자는 서비스를 이용하면서 발생한 개인정보보 관련 문의, 불만처리, 피해구제 등에
              관한 사항을 아래 연락처로 문의해 주시면 성실하고 신속하게 처리결과를 통보하여
              드리겠습니다.
            </p>

            <ol className="list-decimal space-y-2 pl-5" start={1}>
              <p>① 개인정보 보호책임자 : 대표이사 우영진</p>
              <p>② 고객서비스 담당부서 : 고객센터</p>
              <p>③ 연락처 : 02-851-2331</p>
              <p>④ E-mail : mkt@wiezon.com</p>
            </ol>
          </div>

          {/* Section 10 */}
          <div className="space-y-4 text-[13px] sm:text-sm leading-6 sm:leading-7 text-gray-700 mt-8 sm:mt-10">
            <h2 className="text-base sm:text-lg font-semibold text-gray-900">
              10. 이용자의 권익침해 구제방법
            </h2>

            <p>
              1) 이용자는 개인정보침해로 인한 구제를 받기 위하여 개인정보분쟁조정위원회,
              한국인터넷진흥원 개인정보침해신고센터 등에 분쟁해결이나 상담 등을 신청할 수 있습니다.
              기타 개인정보침해의 신고, 상담에 대하여는 아래 기관에 문의하시기 바랍니다.
            </p>

            <ul className="list-disc space-y-2 pl-5">
              <li>개인정보분쟁조정위원회 : (국번없이) 1833-6972(www.kopico.go.kr)</li>
              <li>개인정보침해신고센터 : (국번없이) 118(privacy.kisa.or.kr)</li>
              <li>대검찰청 사이버수사과 : (국번없이) 1301(www.spo.go.kr)</li>
              <li>경찰청 사이버수사국 : (국번없이) 182 (ecrm.cyber.go.kr)</li>
            </ul>

            <p>
              2) 「개인정보 보호법」 제35조(개인정보의 열람), 제36조(개인정보의 정정•삭제),
              제37조(개인정보의 처리정지 등)의 규정에 의한 요구에 대하여 공공기관의 장이 행한 처분
              또는 부작위로 인하여 권리 또는 이익의 침해를 받은 자는 행정심판법이 정하는 바에 따라
              행정심판을 청구할 수 있습니다.
            </p>

            <ul className="list-disc space-y-2 pl-5">
              <li>중앙행정심판위원회 : (국번없이) 110 (www.simpan.go.kr)</li>
            </ul>
          </div>

          {/* Section 11 */}
          <div className="space-y-4 text-[13px] sm:text-sm leading-6 sm:leading-7 text-gray-700 mt-8 sm:mt-10">
            <h2 className="text-base sm:text-lg font-semibold text-gray-900">
              11. 개인정보처리방침의 변경 및 고지의무
            </h2>

            <p>
              이 개인정보처리방침은 2023년 11월 17일부터 적용되며, 법령과 정책 또는 서비스와
              보안사항의 변경사항을 반영하기 위한 목적으로 개인정보처리방침을 수정할 수 있습니다. 현
              개인정보처리방침의 내용 추가, 삭제 및 수정이 발생하면 시행일의 7일전부터 회사
              홈페이지의 공지사항을 통해 고지합니다.
            </p>
          </div>

          <footer className="mt-6 text-[13px] sm:text-sm text-gray-500 text-start">
            <p>공고일자 : 2023년 11월 17일 </p>
            <p>시행일자 : 2023년 11월 24일</p>
          </footer>
        </section>
      </div>
    </main>
  );
}
